import { throttle } from "./throttle";
import { makeDrinksListsToggleable } from "./toggle-drinks";
import { initializeFormitableNewsletter } from "./formitable-newsletter-signup";
import "./reservation-popup";
import { initializeHideIntroVideo } from "./intro-video";

declare const pageBaseUrl: string;

document.addEventListener("DOMContentLoaded", () => {
  const mainMenu = document.querySelector("nav[role=navigation]");
  const mainMenuFlyout = document.querySelector("[data-ref=menu-flyout]");
  const backdrop = document.querySelector("[data-ref=backdrop]");

  // add baseUrl to main menu if we're not on home, to make the #anchor links work
  if (location.href !== pageBaseUrl) {
    Array.from(mainMenu?.querySelectorAll("li.menu-item > a")).forEach(
      (link: HTMLAnchorElement) => {
        const href = link.getAttribute("href");
        if (href?.startsWith("#")) {
          link.href = `${pageBaseUrl}${href}`;
        }
      },
    );
  }

  const isMenuOpen = (): boolean =>
    !mainMenuFlyout.classList.contains("visually-hidden");

  const closeMenuAndHideBackdrop = () => {
    mainMenuFlyout?.classList.add("visually-hidden");
    backdrop?.classList.add("visually-hidden");
  };

  Array.from(mainMenu?.querySelectorAll("li.menu-item > a")).forEach(
    (link: HTMLAnchorElement) =>
      link.addEventListener("click", closeMenuAndHideBackdrop),
  );

  // handler for the menu button opening and closing the menu overlay
  const toggleMainMenu = throttle(() => {
    const menuOpen = isMenuOpen();
    mainMenuFlyout?.classList.toggle("visually-hidden", menuOpen);
    backdrop?.classList.toggle("visually-hidden", menuOpen);
  }, 500);

  // event listener for menu button opening and closing the menu overlay
  document
    .querySelector("[data-ref=menu-button]")
    ?.addEventListener("click", toggleMainMenu);

  // handler method for closing the overlay with ESC key
  const closeMainMenuOnEscOrBackdropClick = (e: KeyboardEvent | MouseEvent) => {
    if (isMenuOpen() && (("key" in e && e.key === "Escape") || !("key" in e))) {
      closeMenuAndHideBackdrop();
    }
  };

  // event listener for keyboard key ESC, closing the overlay
  window.addEventListener("keydown", closeMainMenuOnEscOrBackdropClick);
  // event listener clicking the backdrop, closing the overlay
  backdrop?.addEventListener("click", closeMainMenuOnEscOrBackdropClick);

  // initialize functionality for the toggleable drinks lists
  makeDrinksListsToggleable();

  // initialize custom formitable newsletter signup
  initializeFormitableNewsletter();

  // initialize hiding functions for intro video
  initializeHideIntroVideo();
});
